import type { RuleDefinition } from '../ruleRegistry';

export const GLASS_RULES = [
    {
        id: 'glass.maxPercentPerWall.panorama',
        category: 'glass',
        label: 'Max glasandel per panoramavägg',
        description: 'Intern projekteringsgräns för hur stor del av en vägg som får ersättas av panoramaglas innan bygglovs- och konstruktionsrisk ska flaggas.',
        defaultValue: 0.5,
        valueType: 'number',
        unit: 'andel',
        source: 'BastuByggaren konservativ projekteringsregel; Boverket kräver projekterad säkerhet vid användning men anger inte denna procentsats.',
        dangerLevel: 'critical',
    },
    {
        id: 'glass.panorama.uValueDefault',
        category: 'glass',
        label: 'Standard U-värde panoramaglas',
        description: 'Standardvärde för energigranskning när användaren inte anger ett eget U-värde för panoramaglas.',
        defaultValue: 1,
        valueType: 'number',
        unit: 'W/m²K',
        source: 'Konservativ produktkalibrering tills leverantörsdata finns',
        dangerLevel: 'warning',
    },
    {
        id: 'glass.panorama.safetyGlassThresholdM2',
        category: 'glass',
        label: 'Säkerhetsglas tröskel',
        description: 'Glasarea per vägg över vilken appen varnar att säkerhetsglas och verifierad glasprodukt ska kontrolleras.',
        defaultValue: 1,
        valueType: 'number',
        unit: 'm²',
        source: 'Boverkets regler om personsäkerhet för oskyddade glasytor i byggnader',
        dangerLevel: 'warning',
    },
] as const satisfies readonly RuleDefinition[];
